var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Rules")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.rules.description))]),_vm._v(" "),(_vm.rules.path)?_c('a',{attrs:{"href":_vm.rules.path}},[_vm._v("\n        Download\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }